// components/ResetPassword.js
import React, { useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
// import { Lock, Eye, EyeOff, ArrowLeft } from 'react-feather';
import "bootstrap/dist/js/bootstrap.bundle.min.js";
const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const [formData, setFormData] = useState({
    new_password: "",
    confirm_password: "",
  });
  const [showPassword, setShowPassword] = useState({
    new_password: false,
    confirm_password: false,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const togglePasswordVisibility = (field) => {
    setShowPassword({
      ...showPassword,
      [field]: !showPassword[field],
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.new_password !== formData.confirm_password) {
      setError("Passwords do not match");
      return;
    }

    setIsLoading(true);
    setError("");

    try {
      const response = await fetch(
        "https://ambatturindustrialestate.com/accounts/reset-password/",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            token,
            new_password: formData.new_password,
            confirm_password: formData.confirm_password,
          }),
        }
      );

      if (response.ok) {
        setMessage(
          "Password reset successfully. You can now login with your new password."
        );
      } else {
        setError("Failed to reset password. The link may have expired.");
      }
    } catch (error) {
      setError("An error occurred. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container-fluid vh-100 bg-light">
      <div className="row h-100 justify-content-center align-items-center">
        <div className="col-md-4 col-lg-4">
          <div className="card shadow">
            <div className="card-body p-5">
              <Link
                to="/login"
                className="text-decoration-none d-flex align-items-center mb-4"
              >
                {/* <ArrowLeft size={18} className="me-2" /> */}
                Back to Login
              </Link>

              <div className="text-center mb-4">
                <h2 className="card-title">Reset Password</h2>
                <p className="text-muted">Enter your new password</p>
              </div>

              {message && (
                <div className="alert alert-success" role="alert">
                  {message}
                </div>
              )}

              {error && (
                <div className="alert alert-danger" role="alert">
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="new_password" className="form-label">
                    New Password
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      {/* <Lock size={18} /> */}
                    </span>
                    <input
                      type={showPassword.new_password ? "text" : "password"}
                      className="form-control"
                      id="new_password"
                      name="new_password"
                      value={formData.new_password}
                      onChange={handleChange}
                      required
                    />
                    <button
                      type="button"
                      className="input-group-text"
                      onClick={() => togglePasswordVisibility("new_password")}
                    >
                      {showPassword.new_password ? <p>EyeOff</p> : <p>Eye</p>}
                    </button>
                  </div>
                </div>

                <div className="mb-3">
                  <label htmlFor="confirm_password" className="form-label">
                    Confirm Password
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      {/* <Lock size={18} /> */}
                    </span>
                    <input
                      type={showPassword.confirm_password ? "text" : "password"}
                      className="form-control"
                      id="confirm_password"
                      name="confirm_password"
                      value={formData.confirm_password}
                      onChange={handleChange}
                      required
                    />
                    <button
                      type="button"
                      className="input-group-text"
                      onClick={() =>
                        togglePasswordVisibility("confirm_password")
                      }
                    >
                      {showPassword.confirm_password ? (
                        <p>EyeOff</p>
                      ) : (
                        <p>Eye</p>
                      )}
                    </button>
                  </div>
                </div>

                <div className="d-grid gap-2">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={isLoading}
                  >
                    {isLoading ? "Resetting..." : "Reset Password"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
